import React from 'react';
import PlayerZone from './playerZone.js';
import PublicZone from './publicZone.js';

import './style.css';

export default function () {
  return (
    <div className="">
      <PublicZone />
    </div>
  );
}
